import React from "react";
import { formatBlockKey } from "./StrategyCanvasHelpers";

// Renders the Business Context tab as a grouped list (section headers =
// layer, rows = blocks) per the API contract - blocks without generated
// context are shown as pending rather than omitted.
const StrategyCanvasBusinessContext = ({ layers = [] }) => {
  if (!layers.length) {
    return (
      <div className="scb-empty-state">
        No business context generated yet for this canvas.
      </div>
    );
  }

  return (
    <div className="scb-context-layers">
      {layers.map((layer) => (
        <div className="scb-context-layer" key={layer.layer}>
          <div className="scb-context-layer-title">{layer.layer}</div>
          <div className="scb-context-blocks">
            {(layer.blocks || []).map((block) => (
              <div
                className={`scb-context-block ${block.context ? "" : "pending"}`}
                key={block.block_key}
              >
                <div className="scb-context-block-header">
                  <span className="scb-context-block-title">
                    {formatBlockKey(block.block_key)}
                  </span>
                  {block.confidence ? (
                    <span className={`scb-confidence ${block.confidence}`}>
                      {block.confidence} confidence
                    </span>
                  ) : null}
                </div>
                <p>{block.context || "No context generated yet."}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StrategyCanvasBusinessContext;
